import {
	INACTIVITY_TIMEOUT,
	INACTIVITY_WARNING,
	ACTIVITY_CHECK_INTERVAL,
	LAST_ACTIVITY_KEY
} from "../constants";
import { resetAuth } from "./auth";
import Modal from "../ui/Modal";
import SessionTimeoutModal from "../ui/SessionTimeoutModal";

export const updateLastActivity = (): void => {
	console.log("update last activity");
	localStorage.setItem(LAST_ACTIVITY_KEY, Date.now().toString());
};

let warningModalId: string | null = null;

const checkInactivityTimeout = (): void => {
	const lastActivity = localStorage.getItem(LAST_ACTIVITY_KEY);
	if (!lastActivity) return;

	const elapsed = Date.now() - Number.parseInt(lastActivity, 10);
	const warningMs = INACTIVITY_WARNING * 60 * 1000;
	const timeoutMs = INACTIVITY_TIMEOUT * 60 * 1000;

	console.log(`elapsed : ${elapsed} | warningMs : ${warningMs}ms | timeoutMs : ${timeoutMs}ms`);
	// 30분 경과 → 자동 로그아웃
	if (elapsed >= timeoutMs) {
		performAutoLogout();
		return;
	}

	// 25분 경과 → 경고 팝업 (아직 표시 안 했으면)
	if (elapsed >= warningMs && !warningModalId) {
		showWarningModal();
	}
};

const showWarningModal = (): void => {
	warningModalId = Modal.show(
		SessionTimeoutModal({
			onContinue: handleContinueSession,
			remainingMinutes: INACTIVITY_TIMEOUT - INACTIVITY_WARNING
		})
	);
};

export const handleContinueSession = (): void => {
	if (warningModalId) {
		Modal.close(warningModalId);
		warningModalId = null;
	}
	updateLastActivity();
};

const performAutoLogout = (): void => {
	if (warningModalId) {
		Modal.close(warningModalId);
		warningModalId = null;
	}
	stopActivityMonitor();
	resetAuth();
	window.location.href = "/login?reason=timeout";
};

const handleStorageChange = (e: StorageEvent): void => {
	if (e.key === LAST_ACTIVITY_KEY && e.newValue === null) {
		window.location.href = "/login?reason=timeout";
	}
};

let intervalId: number | null = null;

// 사용자 액션 이벤트 목록
const USER_ACTIVITY_EVENTS = ["keydown", "click", "touchstart", "scroll"] as const;

// 사용자 액션 감지 핸들러
const handleUserActivity = (): void => {
	updateLastActivity();
};

export const startActivityMonitor = (): void => {
	if (intervalId) return;
	updateLastActivity();
	intervalId = window.setInterval(checkInactivityTimeout, ACTIVITY_CHECK_INTERVAL);
	window.addEventListener("storage", handleStorageChange);

	// 사용자 액션 이벤트 리스너 등록
	for (const event of USER_ACTIVITY_EVENTS) {
		window.addEventListener(event, handleUserActivity, { passive: true });
	}
};

export const stopActivityMonitor = (): void => {
	if (intervalId) {
		clearInterval(intervalId);
		intervalId = null;
	}
	if (warningModalId) {
		Modal.close(warningModalId);
		warningModalId = null;
	}
	window.removeEventListener("storage", handleStorageChange);

	// 사용자 액션 이벤트 리스너 제거
	for (const event of USER_ACTIVITY_EVENTS) {
		window.removeEventListener(event, handleUserActivity);
	}

	localStorage.removeItem(LAST_ACTIVITY_KEY);
};
